import { btApi } from '../../btsms/services/btApi';
import { messengerApi } from '../../messenger/services/messengerApi';
import { govNotifyApi } from '../../govuknotifysms/services/govNotifyApi';
import { instagramApi } from '../../messenger/services/instagramApi';
import { whatsAppApi } from '../../messenger/services/whatsappApi';

export interface IAppApiUninstall {
  uninstall(workspaceId: string, installId: string): Promise<void>;
  canUninstall(): boolean;
  getUninstallNotAllowedMessage(): string;
}
const apis: { [key: string]: IAppApiUninstall } = {
  btsms: btApi,
  messenger: messengerApi,
  govuknotifysms: govNotifyApi,
  instagram: instagramApi,
  whatsapp: whatsAppApi,
};

export const AppApiFactory = {
  get: (name: string) => apis[name],
};
